/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './TrustedContacts.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Content from 'services/Content';

import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import { getTrustedContactMappedGroups } from 'state/preferences/PreferencesSelectors';
import AddTrustedContacts from 'components/layouts/Preferences/TrustedContacts/TrustedContactsModal/TrustedContactsModal';
import TrustedContactsBulkDelete from 'components/layouts/Preferences/TrustedContacts/TrustedContactsModal/TrustedContactsDeleteGlobal';
import TrustedContactsTable from 'components/layouts/Preferences/TrustedContacts/TrustedContactsTable';
import { ReactComponent as QuestionCircleIcon } from 'assets/icons/question-circle.svg';
import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';
import LinkButton from 'components/shared/Buttons/LinkButton';
import { getView } from 'state/view/ViewSelectors';

class TrustedContacts extends React.Component {
  state = {
    showEdit: false
  };

  showEditModal = () => {
    this.setState({ showEdit: true });
  };

  closeEditModal = () => {
    this.setState({ showEdit: false });
  };

  render() {
    const { showEdit } = this.state;
    const { accountGroups, view } = this.props;
    const editingEnabled = accountGroups.some((account) => account.isEditable);

    return (
      <Fragment>
        <PreferencesHeader>
          <div className="trusted-contacts-header">Trusted Contacts</div>
        </PreferencesHeader>
        {showEdit && (
          <AddTrustedContacts
            contact={null}
            closeToolTip={this.closeEditModal}
            isAddView={true}
            linkName=""
            modalTitle="Add Trusted Contact"
            openModal={showEdit}
          />
        )}
        <PreferencesSection className="trusted-contacts">
          <PreferencesRow>
            <PreferencesCol col={9} mobile={12}>
              <div className="trusted-contacts-global-actions">
                <div className="trusted-contacts-button-group">
                  {editingEnabled &&
                    <Fragment>
                      <div className="trusted-contacts-modal-container">
                          <LinkButton
                            className="trusted-contacts-link-button"
                            onClick={this.showEditModal}
                            view={view}>
                            Add
                          </LinkButton>
                        </div>
                        <TrustedContactsBulkDelete
                          linkName="Delete"
                          modalTitle="Delete Trusted Contact"
                        />
                    </Fragment>}
                </div>
                <div className={"trusted-contacts-disclaimers-parent"}>
                  <div className="trusted-contacts-disclaimer">
                    Maximum of 2 Trusted Contacts per account.
                  </div>
                  <p className={"trusted-contacts-accounts-owners"}>
                    Only account owner(s) can edit Trusted Contact information.
                  </p>
                </div>
              </div>
              {accountGroups.map((account, key) => (
                <TrustedContactsTable key={key} account={account} />
              ))}
            </PreferencesCol>
            <PreferencesCol col={3} mobile={12}>
              <div className="trusted-contacts-question">
                <div>
                  <QuestionCircleIcon className="trusted-contacts-question-icon" />
                </div>
                <div className="trusted-contacts-question-content">
                  <p className="trusted-contacts-question-info">
                    {Content.trustedContactInfo}
                  </p>
                  <p className="trusted-contacts-question-info">
                    {Content.trustedContactInfoExtended}
                  </p>
                  <DisclosureModal
                    className="restricted-height-modal"
                    title="Additional Information and Terms and Conditions"
                    linkContent="Additional Information and Terms and Conditions"
                    linkContentClass="trusted-contacts-question-link"
                    icon=""
                    content={Content.trustedContactTermsAndConditions}
                  />
                </div>
              </div>
            </PreferencesCol>
          </PreferencesRow>
        </PreferencesSection>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  accountGroups: getTrustedContactMappedGroups(state),
  router: state.router,
  view: getView(state)
});

export default connect(mapStateToProps)(TrustedContacts);
